import script from "./customCurrencyInput.vue?vue&type=script&setup=true&lang=js"
export * from "./customCurrencyInput.vue?vue&type=script&setup=true&lang=js"

import "./customCurrencyInput.vue?vue&type=style&index=0&id=714ca818&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-714ca818"]])

export default __exports__